import * as React from 'react'
import { ReactComponent as Logo } from '../../assets/logo.svg'
import { doLogOut } from '../../common/auth/authActions'
import { IRoute, ROUTES } from '../../common/Routes/routePaths'
import { currentLangString } from '../../i18nInit'
import { store } from '../../index'
//import { LanguageSelection } from '../LanguageSelection/LanguageSelection'
import { YNavLink } from '../YNavLink/YNavLink'
import './Navbar.scss'
import { NavProfile } from './NavProfile/NavProfile'
import { getLogoHref, redirectUrl } from '../../common/helpers/routeHelpers'
import { isNative } from '../../common/helpers/isNative'
import { websiteUrl } from '../../services/apiUrl'
import { Link } from 'react-router-dom'
import { ReactComponent as ArrowBackIcon } from '../../assets/v3/icons/arrow-back.svg'
import { Button } from '../../components/Button/Button'
import { ReactComponent as SyncIcon } from '../../assets/icons/sync.svg'
import { ReactComponent as BellFilledIcon } from '../../assets/v3/icons/notifications/bell-filled.svg'
//import { ReactComponent as SyncIcon } from '../../assets/icons/sync-new.svg'
import { OnboardingStatus, ServiceProvider } from '../../services/api.types'
import { YumLanguageSelection } from '../YumLanguageSelection/YumLanguageSelection'
import A11ySettingsButton from '../A11ySettingsDialog/A11ySettingsButton'
import YumChallengeTitleWrapper from '../YumChallengeTitle/YumChallengeTitleWrapper'
import { Capacitor } from '@capacitor/core'
import { INotification } from '../../common/notifications/NotificationReducers'
import { t } from 'ttag'
import { addNotification } from '../../common/notifications/NotificationActions'
import { scrollToTop } from '../../common/helpers/scroll'
import { clearChatListScroll } from '../../views/Chat/chatListScroll'
import { dataSync, refreshActivityView } from '../../services/DataSync'
import { getUserCompanies } from '../../common/auth/authSelectors'
import { IGlobalState } from '../../Root/store/appReducer'
import Box from '@material-ui/core/Box'

interface INavbarProps {
  routes: IRoute[]
  authenticated: boolean
  fullName?: string
  companyName?: string
  isLanguageSelectionVisible: boolean
  currentRoute: Partial<Location>
  isAdmin: boolean
  isSuperAdmin: boolean
  onboardingStatus: OnboardingStatus
  brandLogoUrl: string
  serviceProvider: string
  unreadNotificationsCount?: number
  chatUnreadCount?: number
  groupChatEnabled?: boolean
}

interface INavbarState {
  isProfileOpen: boolean
}

export class Navbar extends React.Component<INavbarProps, INavbarState> {
  state = { isProfileOpen: false }

  toggleDropdown = () => this.setState(({ isProfileOpen }) => ({ isProfileOpen: !isProfileOpen }))
  hideDropdown = () => this.setState({ isProfileOpen: false })

  // When the bottom tab bar sits at the end of the page (short-viewport reflow
  // mode), the window stays scrolled to the bottom after navigating — bring the
  // new page's content back into view.
  handleNavLinkClick = () => {
    this.hideDropdown()
    // Nav-tab entry into Chat always starts at the top of the channel list; only the in-chat
    // back button restores the saved position.
    clearChatListScroll()
    scrollToTop()
  }

  handleLogout = () => {
    this.toggleDropdown()
    store.dispatch(doLogOut())
  }

  syncData = async () => {
    // const { syncIntegration, getWhoAmI, userDto } = this.props
    const { serviceProvider } = this.props
    const os = Capacitor.getPlatform()
    const appSync =
      (os === 'ios' && serviceProvider === ServiceProvider.APPLE_HEALTH) ||
      (os === 'android' && serviceProvider === ServiceProvider.GOOGLE_FIT)

    /*if (serviceProvider === ServiceProvider.APPLE_HEALTH && os !== 'ios') {
      const notification: INotification = {
        type: 'info',
        content: t`Download YuMuuv from the App Store. Log in with your email and password.`,
      }
      await store.dispatch(addNotification(notification))
      return
    }*/

    // Notify back-end and show message.
    // syncIntegration({ noMessage: false })

    // So people see the message.
    // scrollToTop()

    // If it's Apple Health or Google Fit, initiate sync from front-end.
    if (appSync) {
      await dataSync(true, true)
    }
    // Otherwise show syncing icon for 10 seconds.
    else {
      /*document.body.classList.add('is-syncing')
      getWhoAmI()
      setTimeout(() => {
        refreshActivityView()
        document.body.classList.remove('is-syncing')
      }, 30000)*/
    }
  }

  render() {
    const {
      routes,
      authenticated,
      fullName,
      isLanguageSelectionVisible,
      currentRoute,
      isAdmin,
      isSuperAdmin,
      onboardingStatus,
      brandLogoUrl,
      serviceProvider,
      unreadNotificationsCount,
      chatUnreadCount,
      groupChatEnabled,
    } = this.props
    const { isProfileOpen } = this.state

    let profileRoutes: IRoute[] = []

    // With the group chat feature the main menu slot belongs to Chat, so the notifications
    // feed moves into the profile menu as "Inbox".
    const inboxRoute = { ...ROUTES.NOTIFICATIONS, title: t`Inbox`, icon: BellFilledIcon }

    if (isAdmin) {
      // Super admins land on the super-admin section (/admin/super-admin) instead of
      // the regular admin dashboard.
      const adminRoute = isSuperAdmin ? { ...ROUTES.ADMIN, to: '/admin/super-admin' } : { ...ROUTES.ADMIN }
      profileRoutes = groupChatEnabled
        ? [adminRoute, inboxRoute, { ...ROUTES.SETTINGS }]
        : [adminRoute, { ...ROUTES.SETTINGS }]
    }
    // Non-admin routes
    else if (onboardingStatus === OnboardingStatus.DONE) {
      profileRoutes = groupChatEnabled ? [inboxRoute, { ...ROUTES.SETTINGS }] : [{ ...ROUTES.SETTINGS }]
    }

    const loggedInNav = (
      <NavProfile
        fullName={fullName || ''}
        isProfileOpen={isProfileOpen}
        routes={profileRoutes}
        toggleProfileDropdown={this.toggleDropdown}
        onLogout={this.handleLogout}
        unreadNotificationsCount={unreadNotificationsCount}
      />
    )

    const pathParts = currentRoute.pathname ? currentRoute.pathname.split('/') : []
    const logoHref = getLogoHref(currentRoute.pathname)
    // While mid-verification, the logo should not navigate anywhere.
    const isVerifyEmailPage = currentRoute.pathname === ROUTES.VERIFY_EMAIL.to

    const isChallengePage =
      !!(pathParts[1] === 'challenges' && pathParts[3] && pathParts[3] != 'edit') || pathParts[1] === 'leaderboard'
    const goalId = isChallengePage ? pathParts[2] : undefined
    //const isChatPage = pathParts[3] === 'chat'
    //const backLink = isChatPage ? `${ROUTES.CLIENT_ACTIVITY.to}/${pathParts[2]}` : logoHref
    const backLink = logoHref

    const websiteLocale = ['en', 'et'].includes(currentLangString) ? currentLangString : 'en'
    const websiteHref = `${websiteUrl}/${websiteLocale}`

    return (
      <div className="nav">
        <div className="nav__routes">
          {isVerifyEmailPage ? (
            <div className={isChallengePage ? 'show-on-desktop' : ''} role="img" aria-label={t`YuMuuv`}>
              {brandLogoUrl ? (
                <img src={brandLogoUrl} alt="Brand logo" style={{ height: '40px', width: 'auto' }} />
              ) : (
                <Logo aria-hidden="true" />
              )}
            </div>
          ) : (store.getState() as any).auth.authenticated || isNative() ? (
            <div className={`nav__logo-wrapper${pathParts[1] === 'admin' ? ' nav__logo-wrapper--admin' : ''}`}>
              <Link className="nav__logo-btn" to={backLink} title={t`Back`} aria-label={t`Back`}>
                <ArrowBackIcon aria-hidden="true" />
              </Link>
              <div className={isChallengePage ? 'show-on-desktop' : ''}>
                <Link
                  to={logoHref}
                  className="link nav__logo"
                  onClick={this.hideDropdown}
                  title={t`YuMuuv home`}
                  aria-label={t`YuMuuv home`}
                >
                  {brandLogoUrl ? (
                    <img src={brandLogoUrl} alt="Brand logo" style={{ height: '40px', width: 'auto' }} />
                  ) : (
                    <Logo aria-hidden="true" />
                  )}
                </Link>
              </div>
            </div>
          ) : (
            <>
              <a
                className={isChallengePage ? 'show-on-desktop' : ''}
                href={websiteHref}
                title={t`YuMuuv home`}
                aria-label={t`YuMuuv home`}
              >
                {brandLogoUrl ? (
                  <img src={brandLogoUrl} alt="Brand logo" style={{ height: '40px', width: 'auto' }} />
                ) : (
                  <Logo aria-hidden="true" />
                )}
              </a>
            </>
          )}
          {routes.length > 0 && (
            <nav className="nav__links" aria-label={t`Main`}>
              {/* display: contents keeps the existing flex layout driven by .nav__links */}
              <ul style={{ display: 'contents', listStyle: 'none', margin: 0, padding: 0 }}>
                {routes.map(({ to, title, component, shortTitle, icon: Icon, iconActive: IconActive }, index) => {
                  const isActive = currentRoute.pathname?.startsWith(to)
                  const isChat = to === ROUTES.CHAT.to
                  // Without the group chat feature, the classic Inbox entry points at the
                  // notifications feed and carries the notifications badge.
                  const isInboxItem = to === ROUTES.NOTIFICATIONS.to
                  const isStatistics = to === ROUTES.ADMIN_DASHBOARD.to
                  const badgeCount = isChat ? chatUnreadCount : isInboxItem ? unreadNotificationsCount : 0
                  return (
                    <li key={`nav-item-${index}`} style={{ display: 'contents' }}>
                      <YNavLink
                        className={
                          (isChat || isInboxItem || isStatistics) && isActive ? 'nav__item link-active' : 'nav__item'
                        }
                        to={isStatistics ? ROUTES.ADMIN_DASHBOARD.to + '/dashboard' : to}
                        // Use the base route for active matching so aria-current="page"
                        // is set on any sub-route (e.g. /statistics/fun-facts), matching
                        // the visual active state above.
                        isActive={() => !!currentRoute.pathname?.startsWith(to)}
                        onClick={this.handleNavLinkClick}
                      >
                        {Icon && (
                          <div style={isChat || isInboxItem ? { position: 'relative', order: 3 } : {}}>
                            {IconActive && isActive ? (
                              <IconActive className="nav__icon" />
                            ) : (
                              <Icon className="nav__icon" />
                            )}
                            {badgeCount && badgeCount > 0 ? (
                              <div className="nav__badge">{badgeCount > 9 ? '9+' : badgeCount}</div>
                            ) : (
                              ''
                            )}
                          </div>
                        )}
                        <span className="nav__label" data-title={title}>
                          {title}
                        </span>
                        <span
                          className="nav__label-short"
                          style={isChat || isInboxItem ? { position: 'relative', order: 4 } : {}}
                        >
                          {shortTitle || title}
                        </span>
                      </YNavLink>
                    </li>
                  )
                })}
              </ul>
            </nav>
          )}
        </div>

        {isChallengePage && <YumChallengeTitleWrapper className={'hide-on-desktop'} goalId={goalId} />}

        {isLanguageSelectionVisible && (
          <div style={{ marginTop: '5px', display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Box display={{ xs: 'block', md: 'none' }}>
              <A11ySettingsButton />
            </Box>
            <YumLanguageSelection display={{ xs: 'none', md: 'block' }} />
          </div>
        )}
        {/*{isLanguageSelectionVisible && <LanguageSelection currentLang={getLocale()} isWhite={true} />}*/}
        {authenticated && (
          <div className="nav__profile">
            <Button
              /*onClick={this.syncData}*/
              className={'btn-sync ' /*+ (isNative() ? 'visible' : '')*/}
              link={true}
              iconLeft={SyncIcon}
            />
            {loggedInNav}
          </div>
        )}
      </div>
    )
  }
}
